import { EmployeeType as EmployeeTypeEnum } from '@prisma/client';
import { Radio, RadioGroupProps } from 'antd';

export const EmployeeType = (props: RadioGroupProps) => {
  return (
    <Radio.Group {...props}>
      <Radio value={EmployeeTypeEnum.INTEL}>Intel Employee</Radio>
      <Radio value={EmployeeTypeEnum.CONTINGENT_WORKER}>Contingent Worker</Radio>
    </Radio.Group>
  );
};
